import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { _T } from 'appI18n';
import { GlobalSpinnerContext } from '../GlobalSpinnerProvider';
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error(error, errorInfo);
        this.context.hide();
    }
    render() {
        var _a, _b;
        if (this.state.hasError) {
            return (React.createElement(Alert, { severity: "error", variant: "filled" },
                React.createElement(AlertTitle, null, (_a = _T === null || _T === void 0 ? void 0 : _T.COMMON_CRITICAL_ERROR_TITLE) !== null && _a !== void 0 ? _a : 'COMMON_CRITICAL_ERROR_TITLE'), (_b = _T === null || _T === void 0 ? void 0 : _T.COMMON_CRITICAL_ERROR_BODY) !== null && _b !== void 0 ? _b : 'COMMON_CRITICAL_ERROR_BODY'));
        }
        return this.props.children;
    }
}
ErrorBoundary.contextType = GlobalSpinnerContext;
